import React from 'react';
import smarttechlogo from '../media/images/smart-technology-solutions-white-logo.png';
import smartelectriclogo from '../media/images/smart-electric-solutions-white-logo.png';
import smartconstructionlogo from '../media/images/smart-construction-solutions-white-logo.png';

function Companies(props) {
    const companies = [
        {
            logo: smarttechlogo,
            name: 'Smart Technology Solutions',
            description: 'Innovating smart home solutions to enhance your lifestyle with automation and cutting-edge technology.',
            link: 'https://smart-tech.solutions/',
        },
        {
            logo: smartelectriclogo,
            name: 'Smart Electric Solutions',
            description: 'Providing top-notch electrical services with precision and safety for residential and commercial needs.',
            link: 'https://smartelectric.solutions/',
        },
        {
            logo: smartconstructionlogo,
            name: 'Smart Construction Solutions',
            description: 'Building the future with efficient, reliable, and sustainable construction services.',
            link: 'https://smartconstruction.solutions/',
        },
    ];

    return (
        <section
            id="companies"
            style={{ backgroundColor: '#000', color: 'white', padding: '50px 20px', textAlign: 'center', }} >
            <h2 style={{ fontSize: '2.5rem', marginBottom: '30px', fontWeight: 'bold', }} >
                Our Companies
            </h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', padding: '0 20px', }} >
                {companies.map((company, index) => (
                    <a
                        key={index}
                        href={company.link}
                        style={{
                            backgroundColor: '#111',
                            borderRadius: '10px',
                            padding: '20px',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            textAlign: 'center',
                            overflow: 'hidden',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                            textDecoration: 'none',
                            color: 'white',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-10px)';
                            e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.4)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
                        }}
                    >
                        <img
                            src={company.logo}
                            alt={`${company.name} Logo`}
                            style={{
                                width: '100px',
                                height: 'auto',
                                marginBottom: '20px',
                            }}
                        />
                        <h3
                            style={{
                                fontSize: '1.5rem',
                                marginBottom: '15px',
                                fontWeight: 'bold',
                            }}
                        >
                            {company.name}
                        </h3>
                        <p
                            style={{
                                fontSize: '1rem',
                                lineHeight: '1.5',
                                color: '#bbb',
                            }}
                        >
                            {company.description}
                        </p>
                    </a>
                ))}
            </div>
        </section>
    );
}

export default Companies;
